import React from 'react';
import pick from 'lodash/pick';
import AdminFilterWordProfileStore from 'stores/admin/AdminFilterWordProfileStore';
import AuthStore from 'stores/AuthStore';
import TopicForm from 'components/admin/topics/TopicForm';
import connectToStores from 'alt-utils/lib/connectToStores';
import AdminFilterWordProfileActions from 'actions/admin/AdminFilterWordProfileActions';
import Loading from 'components/pure/utils/Loading';
import AdminTopicEditorPageActions from 'actions/admin/AdminTopicEditorPageActions';
import AdminFilterWordProfileSource from 'sources/admin/AdminFilterWordProfileSource';
import {setStateFromPromise} from 'components/dashboard/rollups/topic/withLoading';
import AdminTopicEditorPageStore from 'stores/admin/AdminTopicEditorPageStore';

/**
 * Fetches data for, and renders, the topic editor form.
 */
@connectToStores
export default class ExistingTopicFormContainer extends React.PureComponent {
  static getStores() {
    return [AdminFilterWordProfileStore, AuthStore];
  }

  static getPropsFromStores() {
    const fwState = AdminFilterWordProfileStore.getState();
    const loading =
      fwState.departmentsLoading || fwState.profilesInAccountLoading || fwState.triggersLoading;
    const loadingError =
      fwState.departmentsError || fwState.profilesInAccountError || fwState.triggersError;
    return {
      editable: AuthStore.getState().user.isAdmin(),
      loading,
      loadingError,
      ...pick(fwState, [
        'idToProfileMap',
        'profileDepartmentAndTeamUsage',
        'triggers',
        'wordsToTopics',
      ]),
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      topicNotFound: false,
      topicLoading: false,
      topicLoadingError: false,
    };
  }

  componentDidMount() {
    const {routeParams} = this.props;
    const {topic} = AdminTopicEditorPageStore.getState();
    if (!topic || !topic.filterWordId === routeParams.filterWordId) {
      // Topic editor isn't initialized properly. Possibly the user navigated to the page directly.
      // Initialize now. We need to fetch the topic to load into the editor's state.
      const promise = AdminFilterWordProfileSource.fetchTopic(routeParams.filterWordId).then(
        topic => AdminTopicEditorPageActions.setupTopicEditorForExistingTopic(topic, false)
      );
      setStateFromPromise(
        this,
        () => promise,
        {topicLoading: true},
        () => ({
          topicLoading: false,
        }),
        e => {
          if (e.response.status === 404) {
            return {topicLoading: false, topicNotFound: true};
          } else {
            console.error(e);
            return {topicLoading: false, topicLoadingError: true};
          }
        }
      );
    }
    // We need all of this for the usage info on the sidebar.
    AdminFilterWordProfileActions.fetchTriggers(routeParams.filterWordId);
    AdminFilterWordProfileActions.fetchAccountProfiles(); // also needed for topic word validation.
    AdminFilterWordProfileActions.fetchDepartments();
  }

  render() {
    const {
      editable,
      idToProfileMap,
      loading,
      loadingError,
      profileDepartmentAndTeamUsage,
      triggers,
      wordsToTopics,
    } = this.props;

    const {topicLoading, topicLoadingError, topicNotFound} = this.state;

    if (loadingError || topicLoadingError) {
      return <p>There was an error loading the data.</p>;
    }
    if (loading || topicLoading) {
      return <Loading />;
    }
    return topicNotFound ? (
      <p>Topic not found.</p>
    ) : (
      <TopicForm
        editable={editable}
        idToProfileMap={idToProfileMap}
        profileDepartmentAndTeamUsage={profileDepartmentAndTeamUsage}
        triggers={triggers}
        wordsToTopics={wordsToTopics}
      />
    );
  }
}
